(function () {
  if (window.italflexBedInfoReady) return;
  var productPath = decodeURIComponent(window.location.pathname).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  if (!/^\/products\/pat-tapitat-/i.test(productPath)) return;
  window.italflexBedInfoReady = true;

  var assets = window.italflexBedInfoAssets || {};
  var lastTrigger = null;
  var previousOverflow = '';

  // APO can toggle off an already selected swatch/button. Preserve required
  // single-choice semantics, without changing optional or checkbox groups.
  var repeatRequiredTarget = null;
  function requiredRadioValue(value) {
    var option = value && value.closest('.mw-option');
    if (!option || !option.classList.contains('mw-option--required')) return null;
    var heading = option.querySelector('.mw-label .mw-text--style-strong');
    if (!heading || !['Dimensiune', 'Tip somieră', 'Sistem de rabatare și depozitare', 'Saltea', 'Culoare', 'Picioare'].includes(heading.textContent.trim())) return null;
    var inputs = Array.from(option.querySelectorAll('.mw-option__control'));
    var input = value.querySelector('input[type="radio"]');
    if (!input || !inputs.length || inputs.some(function (control) { return control.type !== 'radio' || control.name !== input.name; })) return null;
    return input;
  }
  function preventRequiredRadioClear(event) {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    var value = event.target.closest('.mw-option__value');
    if (!value) return;
    var input = requiredRadioValue(value);
    if (event.type === 'pointerdown') {
      repeatRequiredTarget = input && input.checked ? input : null;
      return;
    }
    if (input && (event.type === 'keydown' ? input.checked : repeatRequiredTarget === input)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }
  document.addEventListener('pointerdown', preventRequiredRadioClear, true);
  document.addEventListener('click', preventRequiredRadioClear, true);
  document.addEventListener('keydown', preventRequiredRadioClear, true);

  // One compatibility check for every upholstered bed, independent of the
  // individual APO set. Keep the app's availability/prices authoritative.
  var compatibilityTimer;
  function enforceBedCompatibility() {
    var root = document.querySelector('.mw-apo-container');
    if (!root) return;
    var options = Array.from(root.querySelectorAll('.mw-option'));
    function title(option) {
      var heading = option.querySelector('.mw-label .mw-text--style-strong');
      return heading ? heading.textContent.trim() : '';
    }
    function label(input) { return (input.getAttribute('aria-label') || input.value || '').replace(/×/g, 'x'); }
    var dimensions = options.find(function (option) { return title(option) === 'Dimensiune'; });
    if (!dimensions) return;
    var selected = dimensions.querySelector('input[type="radio"]:checked');
    if (!selected) {
      selected = Array.from(dimensions.querySelectorAll('input[type="radio"]')).find(function (input) {
        var value = input.closest('.mw-option__value');
        return !input.disabled && value && !value.hidden && !value.classList.contains('mw-hidden') && getComputedStyle(value).display !== 'none';
      });
      if (selected) selected.click();
    }
    var size = selected && label(selected).match(/(90|120|140|160|180)\s*x\s*200/);
    if (!size) return;
    size = size[1] + 'x200';
    options.forEach(function (option) {
      if (!['Tip somieră', 'Saltea'].includes(title(option))) return;
      var compatible = [], invalid;
      option.querySelectorAll('.mw-option__value').forEach(function (value) {
        var input = value.querySelector('input[type="radio"]');
        if (!input) return;
        var ownSize = label(input).match(/(90|120|140|160|180)\s*x\s*200/);
        var mismatch = !!ownSize && ownSize[1] + 'x200' !== size;
        if (value.classList.contains('italflex-bed-size-mismatch') !== mismatch) value.classList.toggle('italflex-bed-size-mismatch', mismatch);
        if (input.checked && (mismatch || value.classList.contains('mw-hidden'))) invalid = input;
        if (!mismatch && !value.classList.contains('mw-hidden') && !input.disabled && getComputedStyle(value).display !== 'none') compatible.push(input);
      });
      if (compatible.length && (invalid || !compatible.some(function (input) { return input.checked; }))) {
        var next = compatible.find(function (input) { return /fără saltea/i.test(label(input)); }) || compatible[0];
        next.click();
      }
    });
    if (root.dataset.italflexCompatibleSize !== size) root.dataset.italflexCompatibleSize = size;
  }
  function scheduleCompatibility() {
    if (compatibilityTimer) return;
    compatibilityTimer = setTimeout(function () {
      compatibilityTimer = null;
      enforceBedCompatibility();
    }, 180);
  }
  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('.mw-apo-container input[type="radio"]')) scheduleCompatibility();
  }, true);
  var compatibilityObserver = new MutationObserver(scheduleCompatibility);
  compatibilityObserver.observe(document.documentElement, { childList: true, subtree: true });
  scheduleCompatibility();

  var mattresses = {
    serena: {
      title: 'Saltea Serena',
      image: assets.serena,
      intro: 'Saltea superortopedică din spumă poliuretanică și Memory Foam, fără arcuri.',
      facts: [
        ['↕', 'Înălțime', '24 cm'],
        ['◫', 'Structură', 'Spumă + Memory Foam'],
        ['◆', 'Densitate', '26 kg/m³'],
        ['◎', 'Husă', 'Detașabilă']
      ],
      sections: [
        ['Construcție', ['Bază din spumă poliuretanică, densitate 26 kg/m³.', 'Strat de Memory Foam.', 'Construcție fără arcuri.']],
        ['Husă și finisaje', ['Husă detașabilă, cu fermoar perimetral.', 'Suprafață albă matlasată cu linii longitudinale.', 'Margini finisate cu paspoal.']],
        ['Beneficii', ['Susținere superortopedică.', 'Structură din spumă cu strat de memorie.', 'Finisaj matlasat.']]
      ]
    },
    fresh: {
      title: 'Saltea Fresh',
      image: assets.fresh,
      intro: 'Saltea ortopedică din spumă Flexyfoam și Windyfoam, cu fermitate ridicată și structură respirabilă.',
      facts: [
        ['↕', 'Înălțime', '24 cm'],
        ['◫', 'Structură', 'Flexyfoam + Windyfoam'],
        ['◆', 'Fermitate', 'Ridicată'],
        ['◎', 'Husă', 'Detașabilă, lavabilă la 40°C']
      ],
      sections: [
        ['Construcție', ['Windyfoam de 3 cm, densitate 45 kg/m³: spumă respirabilă și elastică.', 'Flexyfoam de 21 cm, densitate 28 kg/m³: spumă poliuretanică pe bază de apă.', 'Construcție fără arcuri.']],
        ['Husă și întreținere', ['Husă cu efect răcoritor, complet detașabilă și divizibilă cu fermoar.', 'Spălare la mașină la 40°C.', 'Bandă perimetrală 3D pentru circulația aerului.', 'Două mânere laterale pentru poziționare.']],
        ['Beneficii', ['Susținere anatomică.', 'Ventilație și reglarea temperaturii.', 'Rezistență la deformare.', 'Greutate maximă recomandată: 110 kg/persoană.']],
        ['Livrare', ['Livrată rulată.']]
      ]
    },
    easy: {
      title: 'Saltea Easy',
      image: assets.easy,
      intro: 'Saltea superortopedică cu arcuri împachetate individual și strat de Memory Foam, cu fermitate medie.',
      facts: [
        ['↕', 'Înălțime', '25 cm'],
        ['◉', 'Arcuri', '252 arcuri/m²'],
        ['◆', 'Fermitate', 'Medie'],
        ['◎', 'Husă', 'Detașabilă, lavabilă la 40°C']
      ],
      sections: [
        ['Construcție', ['Arcuri împachetate individual: 252 arcuri/m².', 'Strat superior Memory Foam de 3 cm.', 'Box System din poliuretan expandat: 25 kg/m³ în zona de confort și 30 kg/m³ lateral.', 'Două fețe de utilizare: Memory Foam și Flexyfoam.']],
        ['Husă și întreținere', ['Husă detașabilă din poliester matlasat.', 'Material respirabil și rezistent.', 'Spălare la 40°C.']],
        ['Beneficii', ['Susținere adaptată anatomiei corpului.', 'Reduce transferul mișcărilor și punctele de presiune.', 'Greutate maximă recomandată: 110 kg/persoană.']],
        ['Livrare și utilizare', ['Livrată rulată și ambalată în vid.', 'După deschidere, se lasă minimum 12 ore pentru revenirea la forma normală.']]
      ]
    }
  };

  var bases = {
    rulou90: {
      title: 'Somieră tip rulou 90×200',
      intro: 'Somieră fără cadru, inclusă pentru patul de o persoană. Nu este compatibilă cu sistemul de rabatare.',
      image: assets.rulou90,
      facts: [['▤', 'Lamele', '14, mesteacăn stratificat'], ['↔', 'Dimensiune', '90×200 cm'], ['◫', 'Profil lamelă', '64×8 mm'], ['⚖', 'Sarcină', 'Max. 120 kg/persoană']],
      sections: [['Construcție', ['Lamelele sunt unite prin bandă textilă rezistentă.', 'Distanța dintre lamele este de 80 mm.']], ['Beneficii', ['Spațiile dintre lamele ajută la aerisirea saltelei.', 'Suport solid, dar elastic.']]]
    },
    eco90: {
      title: 'Somieră ECO 90×200',
      intro: 'Somieră fixă cu cadru metalic și 13 lamele din lemn multistrat.',
      image: assets.eco90,
      facts: [['▤', 'Lamele', '13, lemn multistrat'], ['↔', 'Dimensiune', '90×200 cm'], ['▱', 'Cadru', 'Oțel 40×30×1,3 mm'], ['⚖', 'Greutate', '16 kg']],
      sections: [['Construcție', ['Lamele de 64×8 mm.', 'Finisaj cu pulbere epoxidică, rezistent la coroziune.']], ['Materiale și certificări', ['Certificări Cosmob și CATAS.', 'Lamele din lemn certificat FSC.']]]
    },
    eco120: {
      title: 'Somieră ECO 120×200',
      intro: 'Somieră fixă inclusă pentru dimensiunea 120×200.',
      image: assets.eco120,
      facts: [['▤', 'Lamele', '13, lemn multistrat'], ['↔', 'Dimensiune', '120×200 cm'], ['━', 'Traversă', 'O bară'], ['⚖', 'Greutate', '18 kg']],
      sections: [['Construcție', ['Cadru din oțel, profil 40×30×1,3 mm.', 'Lamele de 64×8 mm.', 'Finisaj cu pulbere epoxidică.']], ['Materiale și certificări', ['Certificări Cosmob și CATAS.', 'Lamele din lemn certificat FSC.']]]
    },
    sanremo140: {
      title: 'Somieră SANREMO 140×200',
      intro: 'Somieră fixă cu o traversă centrală, concepută pentru susținere stabilă.',
      image: assets.sanremo140,
      facts: [['▤', 'Lamele', '12, lemn multistrat'], ['↔', 'Dimensiune', '140×200 cm'], ['━', 'Traverse', 'O bară centrală'], ['⚖', 'Greutate', '18 kg']],
      sections: [['Construcție', ['Cadru din oțel, profil 40×30×1,3 mm.', 'Lamele de 64×8 mm.']], ['Materiale și certificări', ['Certificări Cosmob și CATAS.', 'Lamele din lemn certificat FSC.']]]
    },
    sanremo160: {
      title: 'Somieră SANREMO 160×200',
      intro: 'Somieră cu o traversă centrală, concepută pentru susținere stabilă.',
      image: assets.sanremo160,
      facts: [['▤', 'Lamele', '12, lemn multistrat'], ['↔', 'Dimensiune', '160×200 cm'], ['━', 'Traverse', 'O bară centrală'], ['⚖', 'Greutate', '22 kg']],
      sections: [['Construcție', ['Cadru din oțel, profil 40×30×1,3 mm.', 'Lamele de 64×8 mm.']], ['Materiale și certificări', ['Certificări Cosmob și CATAS.', 'Lamele din lemn certificat FSC.']]]
    },
    palinuro140: {
      title: 'Somieră ECO 140×200',
      intro: 'Somieră fixă ranforsată, cu două traverse metalice centrale.',
      image: assets.palinuro140,
      facts: [['▤', 'Lamele', '13, lemn multistrat'], ['↔', 'Dimensiune', '140×200 cm'], ['═', 'Traverse', 'Două bare'], ['⚖', 'Greutate', '24 kg']],
      sections: [['Construcție', ['Cadru din oțel, profil 40×30×1,3 mm.', 'Lamele de 64×8 mm.', 'Finisaj cu pulbere epoxidică.']], ['Materiale și certificări', ['Certificări Cosmob și CATAS.', 'Lamele din lemn certificat FSC.']]]
    },
    palinuro160: {
      title: 'Somieră ECO 160×200',
      image: assets.ecoTwoBars,
      imageAlt: 'Somieră ECO cu două bare și mecanism de rabatare, din catalogul furnizorului',
      imageCaption: 'Imagine reprezentativă a gamei ECO cu două bare, din fișa 180×200. Configurația selectată este 160×200. Mecanismul din fotografie este inclus numai dacă alegi „Cu sistem”.',
      intro: 'Somieră fixă ranforsată, cu două traverse metalice centrale.',
      facts: [['▤', 'Lamele', '13, lemn multistrat'], ['↔', 'Dimensiune', '160×200 cm'], ['═', 'Traverse', 'Două bare'], ['✓', 'Certificări', 'Cosmob, CATAS și FSC']],
      sections: [['Construcție', ['Cadru din oțel.', 'Lamele de 64×8 mm.', 'Finisaj cu pulbere epoxidică.']]]
    },
    eco180: {
      title: 'Somieră ECO 180×200',
      image: assets.ecoTwoBars,
      imageAlt: 'Somieră ECO cu două bare și mecanism de rabatare, din fișa 180×200',
      imageCaption: 'Fotografie din catalogul ECO 180×200 cu rabatare. Mecanismul din fotografie este inclus numai dacă alegi „Cu sistem”.',
      intro: 'Somieră ranforsată cu două traverse, pentru stabilitate și durabilitate.',
      facts: [['▤', 'Lamele', '13, lemn multistrat'], ['↔', 'Dimensiune', '180×200 cm'], ['═', 'Traverse', 'Două bare'], ['⚖', 'Greutate', '25 kg']],
      sections: [['Construcție', ['Cadru din oțel, profil 40×30×1,3 mm.', 'Lamele de 64×8 mm.']], ['Materiale și certificări', ['Certificări Cosmob și CATAS.', 'Lamele din lemn certificat FSC.']]]
    }
  };

  function normalize(value) {
    return String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[×–—]/g, 'x');
  }

  var bedDescription = 'Opțiunile disponibile pentru somieră și rabatare depind de modelul și dimensiunea selectate. Tapițeria și picioarele se aleg din opțiunile configuratorului. Salteaua este opțională; modelele disponibile pentru configurația selectată sunt afișate în configurator.';

  function applyBedTemplate() {
    document.querySelectorAll('p').forEach(function (paragraph) {
      if (paragraph.textContent.trim().indexOf('Our goal is for every customer') === 0) {
        paragraph.textContent = bedDescription;
      }
    });

    document.querySelectorAll('table tr').forEach(function (row) {
      var firstCell = row.querySelector('th, td');
      if (firstCell && normalize(firstCell.textContent).trim() === 'dimensiuni') row.remove();
    });

    document.querySelectorAll('button').forEach(function (button) {
      if (normalize(button.textContent).trim() !== 'informatii suplimentare') return;
      var row = button.closest('[data-testid="collapsible-row"], details, .accordion, .accordion__item');
      (row || button.parentElement).remove();
    });
  }

  function selectedText() {
    var configured = document.querySelectorAll('.mw-apo-container input[type="radio"]:checked');
    var selected = configured.length ? configured : document.querySelectorAll('main input[type="radio"][name^="globo-option"]:checked');
    return normalize(Array.from(selected).filter(function (input) {
      var value = input.closest('.mw-option__value');
      if (!value) return true;
      return !value.classList.contains('mw-hidden') && getComputedStyle(value).display !== 'none' && getComputedStyle(value).visibility !== 'hidden';
    }).map(function (input) {
      var label = input.closest('label');
      return [input.value, input.getAttribute('aria-label'), label ? label.innerText : ''].join(' ');
    }).join(' '));
  }

  function hasLiftSystem(text) {
    text = text || selectedText();
    return text.indexOf('cu sistem') > -1 && text.indexOf('fara sistem') === -1;
  }

  // Preserve explicit catalog measurements. On 12 Oct 2026 the merchant
  // confirmed that missing widths use each model's constant L - Ls allowance
  // from LUCIAN - DIMENSIUNI PATURI COPII SITE.xlsx, never a universal +15 cm.
  // Giulia and Matteo/Pluto have non-constant allowances: use explicit sizes.
  var bedFrameAllowances = {
    asti: 10, cannes: 16, capri: 13, chiara: 15, como: 30,
    cortina: 18, dream: 18, ischia: 33, king: 20, luxury: 34,
    monaco: 24, naxos: 25, palermo: 15, portofino: 15, princess: 20,
    queen: 17, roma: 19, sienna: 15, sorrento: 20, lara: 6,
    tara: 6, tulip: 10, valencia: 15, zay: 17
  };
  function missingExteriorWidth(path, selectedWidth) {
    var model = path.split('/').pop().split('-').pop();
    var explicit = { giulia: { 90: 110, 120: 130 }, matteo: { 90: 120, 120: 140 } };
    if (explicit[model]) return explicit[model][selectedWidth] || null;
    if (!Object.prototype.hasOwnProperty.call(bedFrameAllowances, model)) return null;
    return selectedWidth + bedFrameAllowances[model];
  }
  var dimensionSources = new WeakMap();
  function mattressDimensions(value) {
    var match = normalize(value).match(/^(\d+(?:\s*\/\s*\d+)*)\s*x\s*(\d+)\s*(?:cm)?$/);
    return match ? { widths: match[1].split('/').map(Number), length: Number(match[2]) } : null;
  }

  function selectedDimensionValue(source, widths, selectedWidth) {
    var match = String(source).trim().match(/^(\d+(?:[.,]\d+)?(?:\s*\/\s*\d+(?:[.,]\d+)?)+)\s*(?:cm)?$/i);
    if (!match) return source;
    var values = match[1].split('/').map(function (value) { return value.trim(); });
    var index = widths.indexOf(selectedWidth);
    if (values.length !== widths.length || index < 0) return '—';
    return values[index] + ' cm';
  }

  function updateSelectedDimensions() {
    var dimensions = Array.from(document.querySelectorAll('.mw-apo-container .mw-option')).find(function (option) {
      return normalize(option.querySelector('.mw-label .mw-text--style-strong')?.textContent).trim() === 'dimensiune';
    });
    var input = dimensions && dimensions.querySelector('input[type="radio"]:checked');
    var selected = input && mattressDimensions(input.getAttribute('aria-label'));
    if (!selected || selected.widths.length !== 1) return;
    document.querySelectorAll('main table').forEach(function (table) {
      var rows = Array.from(table.querySelectorAll('tr')).map(function (row) {
        var cells = row.querySelectorAll('th, td');
        if (cells.length !== 2) return null;
        if (!dimensionSources.has(cells[1])) dimensionSources.set(cells[1], cells[1].textContent.trim());
        return { label: normalize(cells[0].textContent).trim(), cell: cells[1], source: dimensionSources.get(cells[1]) };
      }).filter(Boolean);
      var reference = rows.find(function (row) { return row.label === 'dimensiuni saltea'; });
      var catalog = reference && mattressDimensions(reference.source);
      if (!catalog || catalog.length !== selected.length) return;
      rows.forEach(function (row) {
        // Only this updater owns dimensions. Restoring cached text for other
        // rows would undo the lift updater and cause an endless observer loop.
        if (!['dimensiuni saltea', 'dimensiune somiera', 'dimensiuni somiera', 'latime', 'lungime', 'inaltime'].includes(row.label)) return;
        var value = row.source;
        if (row === reference || ['dimensiune somiera', 'dimensiuni somiera'].includes(row.label)) {
          var ownDimensions = mattressDimensions(row.source);
          if (ownDimensions && ownDimensions.length === selected.length) {
            value = selected.widths[0] + ' × ' + selected.length + ' cm';
          }
        }
        else if (['latime', 'lungime', 'inaltime'].includes(row.label)) {
          value = selectedDimensionValue(row.source, catalog.widths, selected.widths[0]);
          if (row.label === 'latime' && (!value || String(value).trim() === '—')) {
            if (/\/pat-tapitat-tulip$/i.test(productPath) && selected.widths[0] === 140) value = 'De confirmat';
            else {
              var exterior = missingExteriorWidth(productPath, selected.widths[0]);
              if (exterior !== null) value = exterior + ' cm';
            }
          }
        }
        if (row.cell.textContent.trim() !== value) row.cell.textContent = value;
      });
    });
  }

  function updateSlatBaseCharacteristic() {
    var value = hasLiftSystem()
      ? 'Da, somieră rabatabilă cu spațiu de depozitare'
      : 'Da, somieră fixă';

    document.querySelectorAll('table tr').forEach(function (row) {
      var cells = row.querySelectorAll('th, td');
      if (cells.length < 2) return;
      if (normalize(cells[0].textContent).trim() !== 'somiera inclusa') return;
      if (cells[1].textContent.trim() !== value) cells[1].textContent = value;
    });
  }

  function mattressInfo(text) {
    var source = text.indexOf('serena') > -1 ? mattresses.serena
      : text.indexOf('fresh') > -1 ? mattresses.fresh
      : text.indexOf('easy') > -1 ? mattresses.easy : null;
    if (!source) return null;
    var info = cloneInfo(source);
    var dimensions = Array.from(document.querySelectorAll('.mw-option')).find(function (option) {
      return normalize(option.querySelector('.mw-label .mw-text--style-strong')?.textContent).trim() === 'dimensiune';
    });
    var size = dimensions?.querySelector('input:checked')?.getAttribute('aria-label')?.match(/(90|120|140|160|180)\s*[x×]\s*200/i);
    if (size) {
      info.title += ' – ' + size[1] + '×200';
      info.facts.push(['↔', 'Dimensiune', size[1] + '×200 cm']);
    }
    return info;
  }

  function slatBase(text) {
    if (text.indexOf('rulou') > -1) return bases.rulou90;
    if (text.indexOf('90x200') > -1 && text.indexOf('eco') > -1) return bases.eco90;
    if (text.indexOf('90x200') > -1) return bases.rulou90;
    if (text.indexOf('120x200') > -1) return bases.eco120;
    if (text.indexOf('180x200') > -1 || text.indexOf('standard 180') > -1) return bases.eco180;
    if (text.indexOf('eco') > -1 && text.indexOf('160x200') > -1) return bases.palinuro160;
    if (text.indexOf('eco') > -1) return bases.palinuro140;
    if (text.indexOf('160x200') > -1) return bases.sanremo160;
    return bases.sanremo140;
  }

  function cloneInfo(info) {
    return {
      title: info.title,
      intro: info.intro,
      image: info.image,
      imageAlt: info.imageAlt,
      imageCaption: info.imageCaption,
      facts: info.facts.slice(),
      sections: info.sections.map(function (section) { return [section[0], section[1].slice()]; })
    };
  }

  function slatInfo(text) {
    var info = cloneInfo(slatBase(text));
    var lift = hasLiftSystem(text);
    if (lift && slatBase(text) !== bases.rulou90) {
      if (slatBase(text) === bases.sanremo160) {
        // The catalog documents the complete lifting base, not the bare base.
        // This does not change the approved fixed Shopify shipping mass.
        info.image = assets.sanremo160Lift;
        info.imageAlt = 'Somieră Sanremo 160×200 cu sistem de rabatare';
        info.facts = info.facts.map(function (fact) {
          if (fact[1] === 'Lamele') return [fact[0], fact[1], '13, lemn multistrat'];
          if (fact[1] === 'Greutate') return [fact[0], fact[1], '27 kg, cu sistem'];
          return fact;
        });
      }
      info.title += ' cu sistem de rabatare';
      info.intro += ' Configurația selectată permite accesul la spațiul de depozitare.';
      info.facts.push(['↥', 'Rabatare', 'Pistoane hidraulice']);
      info.sections.push(['Sistem de rabatare și montaj', ['Pistoane hidraulice de 1100 N pentru configurațiile documentate.', 'Sistemul se montează conform instrucțiunilor incluse în colet.']]);
    }
    return info;
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (char) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char];
    });
  }

  function modal() {
    var node = document.getElementById('italflex-bed-info-modal');
    if (node) return node;
    node = document.createElement('div');
    node.id = 'italflex-bed-info-modal';
    node.hidden = true;
    node.innerHTML = '<div class="italflex-info-modal__backdrop" data-close></div><section class="italflex-info-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="italflex-info-title"><button class="italflex-info-modal__close" type="button" aria-label="Închide" data-close>×</button><p class="italflex-info-modal__eyebrow"></p><h2 id="italflex-info-title"></h2><p class="italflex-info-modal__intro"></p><div class="italflex-info-modal__body"></div></section>';
    document.body.appendChild(node);
    node.addEventListener('click', function (event) {
      if (event.target.closest('[data-close]')) closeModal();
    });
    return node;
  }

  function render(info, kind) {
    var image = info.image ? '<figure class="italflex-info-modal__visual"><img class="italflex-info-modal__image" src="' + escapeHtml(info.image) + '" alt="' + escapeHtml(info.imageAlt || info.title) + '">' + (info.imageCaption ? '<figcaption>' + escapeHtml(info.imageCaption) + '</figcaption>' : '') + '</figure>' : '';
    var facts = '<div class="italflex-info-modal__facts">' + info.facts.map(function (fact) {
      return '<div class="italflex-info-modal__fact"><span class="italflex-info-modal__fact-icon" aria-hidden="true">' + escapeHtml(fact[0]) + '</span><strong>' + escapeHtml(fact[1]) + '</strong><span>' + escapeHtml(fact[2]) + '</span></div>';
    }).join('') + '</div>';
    var sections = info.sections.map(function (section) {
      return '<section class="italflex-info-modal__section"><h3>' + escapeHtml(section[0]) + '</h3><ul>' + section[1].map(function (item) { return '<li>' + escapeHtml(item) + '</li>'; }).join('') + '</ul></section>';
    }).join('');
    var node = modal();
    node.querySelector('.italflex-info-modal__eyebrow').textContent = kind === 'saltea' ? 'Informații saltea' : 'Informații somieră';
    node.querySelector('#italflex-info-title').textContent = info.title;
    node.querySelector('.italflex-info-modal__intro').textContent = info.intro;
    node.querySelector('.italflex-info-modal__body').innerHTML = image + facts + sections;
  }

  function openModal(kind, trigger) {
    var text = selectedText();
    var info = kind === 'saltea' ? mattressInfo(text) : slatInfo(text);
    if (!info) return;
    lastTrigger = trigger;
    render(info, kind);
    var node = modal();
    if (node.hidden) previousOverflow = document.body.style.overflow;
    node.hidden = false;
    document.body.style.overflow = 'hidden';
    node.querySelector('.italflex-info-modal__close').focus();
  }

  function closeModal() {
    var node = document.getElementById('italflex-bed-info-modal');
    if (!node || node.hidden) return;
    node.hidden = true;
    document.body.style.overflow = previousOverflow;
    if (lastTrigger && lastTrigger.isConnected) lastTrigger.focus();
  }

  function prepareTriggers() {
    document.querySelectorAll('[data-testid="group-block"] h2').forEach(function (heading) {
      var text = normalize(heading.textContent);
      var group = heading.closest('[data-testid="group-block"]');
      if (!group) return;
      if (text.indexOf('vezi informatii somiera') > -1) group.dataset.italflexInfoKind = 'somiera';
      if (text.indexOf('vezi informatii saltea') > -1) group.dataset.italflexInfoKind = 'saltea';
      if (!group.dataset.italflexInfoKind) return;
      group.setAttribute('role', 'button');
      group.setAttribute('tabindex', '0');
      group.querySelectorAll('a.group-block__link').forEach(function (link) {
        link.removeAttribute('target');
        link.setAttribute('href', '#');
      });
    });
    updateVisibility();
  }

  function updateVisibility() {
    var hasMattress = !!mattressInfo(selectedText());
    document.querySelectorAll('[data-italflex-info-kind="saltea"]').forEach(function (group) {
      group.hidden = !hasMattress;
      group.setAttribute('aria-hidden', hasMattress ? 'false' : 'true');
      if (hasMattress) group.style.removeProperty('display');
      else group.style.setProperty('display', 'none', 'important');
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-italflex-info-kind]');
    if (!trigger) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openModal(trigger.dataset.italflexInfoKind, trigger);
  }, true);

  document.addEventListener('keydown', function (event) {
    var node = document.getElementById('italflex-bed-info-modal');
    if (node && !node.hidden) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }
      if (event.key === 'Tab') {
        var controls = Array.from(node.querySelectorAll('button, a[href], input, select, textarea, [tabindex="0"]')).filter(function (control) {
          return !control.disabled && control.getClientRects().length;
        });
        var first = controls[0];
        var last = controls[controls.length - 1];
        if (first && ((event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last))) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        }
      }
    }
    if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('[data-italflex-info-kind]')) {
      event.preventDefault();
      openModal(event.target.dataset.italflexInfoKind, event.target);
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('main input[type="radio"]')) {
      setTimeout(updateVisibility, 0);
      setTimeout(updateVisibility, 160);
      setTimeout(updateSlatBaseCharacteristic, 0);
      setTimeout(updateSlatBaseCharacteristic, 160);
      setTimeout(updateSelectedDimensions, 0);
      setTimeout(updateSelectedDimensions, 160);
    }
  }, true);

  function refreshBedUi() {
    applyBedTemplate();
    prepareTriggers();
    updateSlatBaseCharacteristic();
    updateSelectedDimensions();
  }

  var bedUiObserver = new MutationObserver(refreshBedUi);
  bedUiObserver.observe(document.documentElement, {childList: true, subtree: true});
  window.addEventListener('pagehide', function () {
    compatibilityObserver.disconnect();
    bedUiObserver.disconnect();
    clearTimeout(compatibilityTimer);
    compatibilityTimer = null;
  });
  window.addEventListener('pageshow', function () {
    compatibilityObserver.observe(document.documentElement, {childList: true, subtree: true});
    bedUiObserver.observe(document.documentElement, {childList: true, subtree: true});
    scheduleCompatibility();
    refreshBedUi();
  });
  refreshBedUi();
  document.addEventListener('shopify:section:load', refreshBedUi);
})();
